(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[329],{

/***/ 5066:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_partners/[partnerSlug]/[...pageSlug]",
      function () {
        return __webpack_require__(7108);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var components_AppChrome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1904);
/* harmony import */ var components_document_DocumentContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1084);
/* harmony import */ var components_document_DocumentPageHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3451);
/* harmony import */ var components_heroes_HeroIllustration__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9379);
/* harmony import */ var components_layout_Background__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7940);
/* harmony import */ var components_pageSegments_PageSegments__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1135);







function Page(param) {
    var page = param.entry;
    var ref, ref1, ref2, ref3;
    var navigationBar = page === null || page === void 0 ? void 0 : (ref = page.navigationMenu) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.navigationBar;
    var footerPageSegments = page === null || page === void 0 ? void 0 : (ref2 = page.footer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.pageSegments;
    if (page.typeHandle === "document") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_AppChrome__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                navigationBar: navigationBar,
                footerPageSegments: footerPageSegments,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_layout_Background__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        $color: "grey100",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_document_DocumentPageHeader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                title: page.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_document_DocumentContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                contentBlocks: page.documentContent
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_pageSegments_PageSegments__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        pageSegments: page.pageSegments
                    })
                ]
            })
        });
    }
    var illi = page.heroIllustration[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_AppChrome__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            navigationBar: navigationBar,
            footerPageSegments: footerPageSegments,
            children: [
                illi && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_heroes_HeroIllustration__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    title: page.mainTitle,
                    subtitle: page.subtitle,
                    image: illi.image[0],
                    objectPosition: illi.objectPosition,
                    imagePosition: illi.horizontalAlignment,
                    bgColor: illi.backgroundColor,
                    containerCSS: illi.containerCss,
                    buttonLabel: page.buttonLabel,
                    buttonLink: page.buttonLink,
                    partnerLabel: page.partnerLabel,
                    partnerLogos: page.logos,
                    testimonial: page.testimonial[0]
                }),
                !illi && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_document_DocumentPageHeader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    title: page.mainTitle,
                    centered: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_pageSegments_PageSegments__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    pageSegments: page.pageSegments
                })
            ]
        })
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,756,274,783,135,379,702,888,179], function() { return __webpack_exec__(5066); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);